import { useCallback, useState } from 'react'
import { useSocketListener } from './sockets/useSocket'

export const usePriceFeed = (assetId) => {
  const [priceFeedCache, setCache] = useState({})
  const [priceFeedHeartbeat, setHeartbeat] = useState(true)

  useSocketListener('priceFeed', 'price-feed', (priceFeedMsg) => {
    setCache(priceFeedMsg)
    setHeartbeat((prev) => !prev)
  })

  const getPriceFeed = useCallback(
    (assetId) => {
      return priceFeedCache[assetId]
    },
    [priceFeedCache]
  )
  const priceFeed = getPriceFeed(assetId)
  return assetId ? { priceFeed: { ...priceFeed }, priceFeedHeartbeat } : { getPriceFeed, priceFeedHeartbeat }
}
